module.exports = __webpack_public_path__ + "static/media/rasaiya.4ffbb3d2.png";